import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { zh } from './locales/zh'
import { en } from './locales/en'

const resources = {
  zh: {
    translation: zh
  },
  en: {
    translation: en
  }
}

// Initialize i18n synchronously
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Set default language (English - no URL prefix)
    fallbackLng: 'en',
    debug: false, // Disable debug in production
    
    interpolation: {
      escapeValue: false
    },
    
    react: {
      useSuspense: false
    },
    
    // Enable nested key separator
    keySeparator: '.',
    nsSeparator: false,
    
    // Set supported languages
    supportedLngs: ['zh', 'en'],
    
    // Load resources synchronously
    initImmediate: false
  })

export default i18n